/**
 * @file   : GeoMapStaticCmp.js
 * @author :  ()
 * @date   : 7/29/2019, 6:21:24 PM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Cont, { ALIGN_CENTER } from '../../../external/components/layout/Cont'
import AImg from '../../../external/components/media/img/AImg'
import { isEmpty, isValue } from '../../../external/utilities/GeneralUtils'
import { getQueryStringFromObj } from '../../../utilities/QueryParamUtils'

export const MAPTYPE_ROADMAP = 'roadmap'
export const MAPTYPE_SATELLITE = 'satellite'
export const MAPTYPE_TERRAIN = 'terrain'
export const MAPTYPE_HYBRID = 'hybrid'

class GeoMapStaticCmp extends Component {
  shouldShow() {
    const { mapBaseURL, mapFullURL, centerLat, centerLng, showMap } = this.props
    if (
      (!isEmpty(mapBaseURL) &&
        isValue(centerLat) &&
        isValue(centerLng) &&
        showMap) ||
      (!isEmpty(mapFullURL) && showMap)
    ) {
      return true
    }

    return false
  }

  getMapURL() {
    const {
      mapBaseURL,
      mapFullURL,
      centerLat,
      centerLng,
      height,
      width,
      maptype,
      defaultMarker,
      zoom,
      mapKey,
      signature,
    } = this.props
    const paramObj = {}

    if (!isEmpty(mapFullURL)) {
      return mapFullURL
    }

    if (isValue(centerLat) && isValue(centerLng)) {
      paramObj.center = `${centerLat.toString()},${centerLng.toString()}`
    }

    paramObj.size = `${width.toString()}x${height.toString()}`
    paramObj.maptype = maptype

    let markersString = ''
    if (!isEmpty(defaultMarker) && isValue(centerLat) && isValue(centerLng)) {
      markersString += `icon:${defaultMarker.externalServerBaseURL}${
        defaultMarker.mainIcon
      }|${centerLat.toString()},${centerLng.toString()}`
    }
    if (markersString !== '') {
      paramObj.markers = markersString
    }

    if (isValue(zoom) && zoom >= 0) {
      paramObj.zoom = zoom
    }

    paramObj.key = mapKey

    if (!isEmpty(signature)) {
      paramObj.signature = signature
    }

    return mapBaseURL + getQueryStringFromObj(paramObj)
  }

  render() {
    if (!this.shouldShow()) {
      return <Cont />
    }

    const { asBackground, cmpLabel, cmpTitle } = this.props
    const url = this.getMapURL()
    const bgImageStyle = {
      backgroundImage: `url(${url})`,
      height: `${this.props.height}px`,
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
      'background-position': 'center center',
      position: 'relative',
    }

    if (asBackground) {
      return <div title={cmpTitle} aria-label={cmpLabel} style={bgImageStyle} />
    }

    return (
      <Cont align={ALIGN_CENTER}>
        <AImg
          imageURL={url}
          responsive
          cmpTitle={cmpTitle}
          cmpLabel={cmpLabel}
        />
      </Cont>
    )
  }

  static propTypes = {
    mapBaseURL: PropTypes.string,
    mapFullURL: PropTypes.string,
    showMap: PropTypes.bool,
    centerLat: PropTypes.number,
    centerLng: PropTypes.number,
    height: PropTypes.number,
    width: PropTypes.number,
    zoom: PropTypes.number,
    defaultMarker: PropTypes.object,
    asBackground: PropTypes.bool,
    maptype: PropTypes.oneOf([
      MAPTYPE_ROADMAP,
      MAPTYPE_SATELLITE,
      MAPTYPE_TERRAIN,
      MAPTYPE_HYBRID,
    ]),
    mapKey: PropTypes.string,
    signature: PropTypes.string,
    cmpTitle: PropTypes.string,
    cmpLabel: PropTypes.string,
  }

  static defaultProps = {
    mapBaseURL: null,
    mapFullURL: null,
    zoom: -1,
    height: 400,
    width: 640,
    showMap: true,
    asBackground: false,
    maptype: MAPTYPE_ROADMAP,
    defaultMarker: {},
    mapKey: '',
    signature: null,
    cmpTitle: null,
    cmpLabel: null,
  }
}

export default GeoMapStaticCmp
